export default __webpack_public_path__ + "static/media/whatsapp.1786ffe2.svg";